import {
  TRAVERSAL_STATE_SCHEMA_VERSION,
  type TraversalState,
} from "./types.ts";

export const TRAVERSAL_SAVE_KEY = "vilnius.traversal.v1";

export function serializeTraversalSave(state: Readonly<TraversalState>): string {
  return JSON.stringify(state);
}

export function parseTraversalSave(value: string): TraversalState {
  const parsed: unknown = JSON.parse(value);
  if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
    throw new Error("Traversal save must be an object");
  }
  const record = parsed as Record<string, unknown>;
  if (record.schemaVersion !== TRAVERSAL_STATE_SCHEMA_VERSION) {
    throw new Error("Unsupported traversal save schemaVersion");
  }
  if (
    !Array.isArray(record.discoveredSiteIds) ||
    !record.discoveredSiteIds.every((id) => typeof id === "string") ||
    new Set(record.discoveredSiteIds).size !== record.discoveredSiteIds.length
  ) {
    throw new Error("Traversal save has invalid discovered site IDs");
  }
  return {
    schemaVersion: TRAVERSAL_STATE_SCHEMA_VERSION,
    discoveredSiteIds: [...record.discoveredSiteIds] as string[],
  };
}

